import { Container } from "@/components/ui/container";
import S from "./index.module.scss";

interface DesignStoryProps {
  title: string;
  description: string;
}

const DesignStory = ({ title, description }: DesignStoryProps) => {
  return (
    <section className={S.story}>
      <Container className={S.container}>
        <div className={S.headingBlock}>
          <p className={S.eyebrow}>О дизайне</p>
          <h2 className={S.title}>{title}</h2>
        </div>

        <div className={S.copyBlock}>
          <p className={S.copy}>{description}</p>
        </div>
      </Container>
    </section>
  );
};

export default DesignStory;
